import { DiscountCarousel } from "@/components/isic/DiscountCarousel";
import { ROMANIA_DISCOUNTS, INTERNATIONAL_DISCOUNTS, APP_LINKS } from "@/data/content";

const SectionHeading = ({ children }) => (
  <div className="mb-12 flex flex-col items-center px-6">
    <h2 className="text-center text-3xl font-extrabold tracking-tight text-slate-800 md:text-4xl">
      {children}
    </h2>
    <span className="mt-5 h-1.5 w-20 rounded-full bg-[#2f68b0]" />
  </div>
);

const SectionButton = ({ href, children, testId }) => (
  <div className="mt-14 flex justify-center">
    <a href={href} target="_blank" rel="noopener noreferrer" className="isic-btn" data-testid={testId}>
      {children}
    </a>
  </div>
);

export const RomaniaDiscounts = () => (
  <section className="bg-[#f6f9fc] py-16 md:py-24" data-testid="romania-discounts-section">
    <SectionHeading>Top reduceri în România cu legitimația ta ISIC</SectionHeading>
    <DiscountCarousel items={ROMANIA_DISCOUNTS} gap={24} testId="romania-carousel" />
    <SectionButton href={APP_LINKS.moreRomania} testId="more-romania-btn">
      Mai multe reduceri în România
    </SectionButton>
  </section>
);

export const InternationalDiscounts = () => (
  <section className="bg-white py-16 md:py-24" data-testid="international-discounts-section">
    <SectionHeading>Top reduceri internaționale cu legitimația ta ISIC</SectionHeading>
    <DiscountCarousel items={INTERNATIONAL_DISCOUNTS} gap={24} testId="international-carousel" />
    <SectionButton href={APP_LINKS.moreInternational} testId="more-international-btn">
      Mai multe reduceri internaționale
    </SectionButton>
  </section>
);
